import * as link from '@/api/link'

const state = {
  list: [],
  listaSelect: [],
  filtros: {nome: '', grupo: '', page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalDel: false,
  modalConfDel: false
}

const mutations = {
  SETLINKS (state, payload) {
    state.list = payload.list
  },
  HIDDEMODAL (state) {
    state.modalAdd = false
    state.modalEdit = false
    state.modalConfDel = false
  },
  MODALADD (state) {
    state.modalAdd = !state.modalAdd
  },
  MODALEDIT (state) {
    state.modalEdit = !state.modalEdit
  },
  MODALCONFDEL (state) {
    state.modalConfDel = !state.modalConfDel
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  }
}

const actions = {
  hiddeModal: function ({ commit }) {
    commit('HIDDEMODAL')
  },
  modalAdd: function ({ commit }) {
    commit('MODALADD')
  },
  modalEdit: function ({ commit }) {
    commit('MODALEDIT')
  },
  modalConfDel: function ({ commit }) {
    commit('MODALCONFDEL')
  },
  async get ({ commit }, payload) {
    let data = await link.get(payload)
    return data
  },
  async getLinks ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await link.getLinks(payload)
    commit('SETLINKS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getLinksFiltro ({ commit, dispatch }) {
    let data = await link.getLinks(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETLINKS', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async add ({ commit }, payload) {
    try {
      await link.add(payload)
      return true
    } catch (e) {
      return e
    }
  },
  async edit ({ commit }, payload) {
    try {
      await link.edit(payload)
      return true
    } catch (e) {
      return e
    }
  },
  async delLink ({ commit }, payload) {
    try {
      let retorno = await link.delLink(payload)
      return retorno
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getLinks', state.filtros)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/link.js